import React from 'react';
import Logo from '../../ui/components/Logo/logo';
import links, { privacyPolicyLink, termsOfServiceLink } from '../../links';
import './style.scss';

const {
    infoPages: {
        about: aboutUrl,
        faq: faqUrl,
        support: supportUrl,
    },
} = links;

const FooterNavigation = () => (
    <footer className="footer bg-navy-9">
        <div className="content">
            <div className="links">
                <a href={aboutUrl}>
                    About
                </a>
                <a href={faqUrl} target="_blank" rel="noopener noreferrer">
                    FAQ
                </a>
                <a href={privacyPolicyLink} target="_blank" rel="noopener noreferrer">
                    Privacy Policy
                </a>
                <a href={termsOfServiceLink} target="_blank" rel="noopener noreferrer">
                    Terms of Service
                </a>
                <a href={supportUrl} target="_blank" rel="noopener noreferrer">
                    Contact Us
                </a>
            </div>
            <div className="contact-info">
                <div>
                    Submit Inquiry to{' '}
                    <a href={supportUrl} target="_blank" rel="noopener noreferrer">
                        Member Services
                    </a>
                </div>
                <div>2875 South Ocean Blvd</div>
                <div>Suite 200-08</div>
                <div>Palm Beach, FL 33480</div>
                <div className="company-name">
                    © {new Date().getFullYear()} Healthcasts, LLC. All rights reserved.
                </div>
            </div>
            <div className="logo-area">
                <Logo isAdmin={false} />
            </div>
        </div>
    </footer>
);

export default FooterNavigation;
